import React, { ChangeEvent } from 'react';

import styles from './SimpleCheckbox.module.scss';

export interface SimpleCheckboxProps {
  checked: boolean;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  text?: string;
  disabled?: boolean;
  customLabel?: boolean;
  children?: React.ReactNode;
}

export const SimpleCheckbox = ({
  text,
  checked,
  onChange,
  disabled = false,
  customLabel = false,
  children,
}: SimpleCheckboxProps) => {
  return (
    <label
      className={`form-label ${styles.simpleCheckbox}`}
      data-disabled={disabled}
    >
      <span className={styles.checkboxBox}>
        <input
          type="checkbox"
          checked={checked}
          onChange={onChange}
          disabled={disabled}
        />
        {checked ? (
          <span className={styles.checked}>
            <i className="icon fas fa-check" aria-hidden="true"></i>
          </span>
        ) : null}
      </span>
      {!customLabel && text && (
        <span className={styles.rcCheckboxLabel}>{text}</span>
      )}
      {customLabel && children}
    </label>
  );
};
